import { ROUTES } from './routeNames';

export const serviceUrl = (route) => {
  const routesArray = [
    ROUTES.ABOUT_US,
    ROUTES.CONTACT_US,
    ROUTES.HOT_TOURS,
    ROUTES.WELCOME,
  ];
  return routesArray.includes(route);
};

export const scrollTop = () => window.scrollTo(0, 0);

export const dateValidFormat = (date = '', format = 'en-US') => {
  // FORMATS -[ 'ru' , 'en-US', 'en-UK' ]
  const now = new Date(date);
  const validDate = new Intl.DateTimeFormat(format);

  return validDate.format(now);
};
